import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function HeaderCap() {
  const theme = useContext(ThemeContext);
  return (
    <g>
      <path
        d="M0,84.3007813 C194.405564,59.0976563 382.766982,54.3307292 565.084256,70 C747.401529,85.6692708 900.373444,87.9908854 1024,76.9648437 L1024,-4.26325641e-14 L0,-4.26325641e-14 L0,84.3007813 Z"
        fill={theme.colors.brand}
      ></path>
      <path
        d="M0,0 L1024,0 L1024,70 C765.027778,49.4192708 578.19184,39.1289063 463.492187,39.1289063 C348.792535,39.1289063 194.295139,49.4192708 0,70 L0,0 Z"
        fill={theme.colors.accent}
      ></path>
    </g>
  );
}
